import { wrapGqlRequest } from "./graphqlEndPointCommonSetting/wrapGqlRequest";

export const doGetPaymentIntent = async ({
  cartId,
  cartFullName,
  gaClientId,
  gaSessionId,
}) => {
  const query = `
  query GetStripePaymentIntent($cartId: String!, $cartFullName: String, $gaClientId: String, $gaSessionId: String) {
    getStripePaymentIntent(input: {cartId: $cartId cartFullName: $cartFullName gaClientId: $gaClientId gaSessionId: $gaSessionId}) {
      client_secret
      error
    }
  }
`;
  const variables = {
    cartId,
    cartFullName,
    gaClientId,
    gaSessionId,
  };

  const response = await wrapGqlRequest(
    query,
    variables,
    "getStripePaymentIntent",
  );
  // GraphQL-level errors

  const error = response?.error;

  //  GraphQL array error
  if (Array.isArray(error) && error.length > 0) {
    return {
      error: error[0]?.message || "Something went wrong",
    };
  }

  //  String error
  if (typeof error === "string" && error.trim().length > 0) {
    return {
      error: error,
    };
  }

  //  Object error (Magento resolver case)
  if (typeof error === "object" && error !== null) {
    return {
      error: error.message || "Something went wrong",
    };
  }

  return {
    clientSecret: response.client_secret,
  };
};

export const doGetOrderStatus = async ({ incrementId }) => {
  try {
    const variables = {
      incrementId: incrementId,
    };

    const query = `
          query GetOrderStatus($incrementId: String!) {
  getOrderStatus(input: { increment_id: $incrementId }) {
    order {
      increment_id
      id
      status
    }
    success
  }
}    
        `;
    const response = await wrapGqlRequest(query, variables, "getOrderStatus");
    console.log("doGetOrderStatus", response);

    return response?.order || {};
  } catch (error) {
    console.error("❌ GraphQL Catalog Products Error:", error);
    throw error;
  }
};
